import Link from "next/link";
import PopularGames from "../components/PopularGames";
export default function GameCommonDis() {
  return (
    <div className="dis-container">
      <div className="thumb-dis">
        <div className="dis">
          <h2 className="contant name">
            Play free Cute games at playcutegames.com 
          </h2>
          <div className="contant para description">
            {/* {" "}
            <Link href="/"title="playcutegames">Playcutegames
            </Link> */}
          Welcome to Playcutegames, your premier destination for
          {" "}<Link target="_blank" href="/categories/girl-games" title="girl games" passHref>girl games</Link>
            ! Explore our trendy selection of fashionable
            {" "}<Link target="_blank" href="/categories/princess-games" title="princess games" passHref>princess games</Link>{" "}
            and girl-centric delights. Dive into a world of awesome 
            {" "}<Link target="_blank" href="https://bestgamespot.com/" title="free online games" passHref>free online games</Link>{" "}
            tailored for girls. Elevate your dress-up prowess with our princess 
            {" "}<Link target="_blank" href="/categories/dress-up-games" title="dress up games" passHref>dress up games</Link>.{" "}
            Hone your culinary talents with our special
            {" "}<Link target="_blank" href="/categories/cooking-games" title="cooking games" passHref>cooking games</Link>.{" "}
            Immerse yourself in{" "}<Link target="_blank" href="/categories/decoration-games" title="decoration games" passHref>decoration games</Link>,{" "}including
            {" "}<Link target="_blank" href="/game/princess-pastel-fashion" title="pastel fashion games" passHref>pastel fashion games</Link>,{" "} 
            {" "}<Link target="_blank" href="/categories/christmas-games" title="Christmas games" passHref>Christmas games</Link>,{" "}
            Easter games, and medieval Chinese fashion games. For a twist, try out our wild challenge games like
            {" "}<Link target="_blank" href="/game/princess-stripe-vs-dots" title="Stripes vs. Dots" passHref>Stripes vs. Dots</Link>,{" "}
            where princesses compete in fashion
            {" "}<Link target="_blank" href="https://cutedressup.com/" title="dress up games" passHref>dress up games</Link>!{" "} Join the fun today!
          </div>
          <PopularGames />
        </div>
      </div>
    </div>
  );
}
